import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TabHeaderComponent } from './tab-header.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    TabHeaderComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    TabHeaderComponent
  ],
  providers: []
})
export class TabHeaderModule {}
